import React from "react"
import { useParams, Navigate } from "react-router-dom"
import getAppConfig from "~/utils/getAppConfig"
import { useToast } from "~/utils/Toast"

import { apiWorkspaceDeals, apiWorkspaceDealStages } from "~/routes"
import useFetchResource from "~/hooks/useFetchResource"

import PageContainer from "~/library/PageContainer"
import LoadingWrapper from "~/library/LoadingWrapper"
import DealForm from "./DealForm"
import type Deal from "~/types/Deal"

type DealStageOption = {
    id: string
    name: string
}

const EditDeal = () => {
    const { venueSlug } = getAppConfig()
    const { id } = useParams<{ id: string }>()
    const [isUpdated, setIsUpdated] = React.useState(false)
    const toast = useToast()

    const { data: deal, isLoading: dealLoading } = useFetchResource<
        { deal: Deal },
        "deal"
        >(apiWorkspaceDeals.show.path({ venue_slug: venueSlug, id: id! }), "deal", {})

    const { data: dealStages, isLoading: stagesLoading } = useFetchResource<
        DealStageOption[],
        "deal_stages"
        >(apiWorkspaceDealStages.index.path({ venue_slug: venueSlug }), "deal_stages", {})

    const handleSubmit = async (formValues: any) => {
        try {
            const url = apiWorkspaceDeals.update.path({
                venue_slug: venueSlug,
                id: id!
            })

            const response = await fetch(url, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    deal: formValues,
                }),
            })

            const result = await response.json()

            if (result.status === 'ok') {
                setIsUpdated(true)
                toast("Deal updated successfully", "success")
            } else {
                toast(
                    `Error updating deal. ${result.errors?.join(", ") || "Please try again"}`,
                    "danger"
                )
            }
        } catch (error) {
            console.error("Error:", error)
            toast("Error updating deal. Please try again", "danger")
        }
    }

    if (isUpdated) {
        return <Navigate to={`/deals/${id}`} />
    }

    const isLoading = dealLoading || stagesLoading

    return (
        <PageContainer>
            <LoadingWrapper isLoading={isLoading}>
                <div className="row h-100">
                    <div className="col-8 offset-2 align-center mt-4">
                        <h3 className="mb-3">Edit Deal</h3>
                        {deal && dealStages && (
                            <>
                                {console.log('Deal dealType:', deal.dealType)}
                                {console.log('dealTypeId for form:', deal.dealType?.id)}
                                <DealForm
                                    onSubmit={handleSubmit}
                                    initialValues={{
                                        name: deal.name,
                                        dealTypeId: deal.dealType?.id || "",
                                        dealStageId: deal.dealStage?.id || "",
                                        salesRepId: deal.salesRep?.id || "",
                                        value: deal.value || "",
                                        probability: deal.probability || "",
                                        expectedCloseDate: deal.expected_close_date || "",
                                    }}
                                    dealStages={dealStages}
                                    initialAccount={deal.account ? {
                                        id: deal.account.id,
                                        name: deal.account.name
                                    } : null}
                                    initialContacts={deal.contacts || []}
                                    isEditing={true}
                                />
                            </>
                        )}
                    </div>
                </div>
            </LoadingWrapper>
        </PageContainer>
    )
}

export default EditDeal
